import moment from "moment";
import store from "@/store";

const CASE_SINGLE_CUSTOMER_PRICE = "CASE_SINGLE_CUSTOMER_PRICE";
const CASE_CUSTOMER_PRICE = "CASE_CUSTOMER_PRICE";
const CASE_SINGLE = "CASE_SINGLE";
const CASE_NORMAL = "CASE_NORMAL";

export interface IProduction {
  item_carton_code?: string;
  item_code: string;
  item_name_1: string;
  item_name_2: string;
  carton_description: string;
  unit_quantity: number;
  unit_name: string;
  can_deliver_today: boolean;
  created: string;
  item: Item;
  customer_price: CustomerPrice;
}

export class ProductionDTO implements IProduction {
  item_carton_code?: string;
  item_code: string;
  item_name_1: string;
  item_name_2: string;
  carton_description: string;
  unit_quantity: number;
  unit_name: string;
  can_deliver_today: boolean;
  delivery_day_inquiry_kbn: number;
  created: string;
  item: Item;
  customer_price: CustomerPrice;
  deleted: string;
}

import { DATE_TIME_FORMAT } from "@/common/constant";
import Item from "./item";
import CustomerPrice from "./customerPrice";
import User from "./user";

export default class Production extends ProductionDTO {
  createdDateTime;

  constructor(dto: ProductionDTO) {
    super();
    Object.assign(this, dto);
    this.createdDateTime = moment(this.created);
  }

  get createdAt(): string {
    return this.createdDateTime.format(DATE_TIME_FORMAT);
  }

  get getProductionName(): string {
    return this.getName1 + " " + this.getName2;
  }

  get getName1(): string {
    const productCase = this.getCase;
    if (productCase === CASE_CUSTOMER_PRICE) {
      // case #3-1
      return this.customer_price.item_name_1;
    } else if (productCase === CASE_SINGLE_CUSTOMER_PRICE) {
      // case #3-2
      return this.customer_price.item_name_1;
    } else if (productCase === CASE_SINGLE) {
      // case #1
      return this.item.item_name_1;
    }
    return this.item.item_name_1;
  }

  get getName2(): string {
    const productCase = this.getCase;
    if (productCase === CASE_CUSTOMER_PRICE) {
      // case #3-1
      return this.customer_price.item_name_2;
    } else if (productCase === CASE_SINGLE_CUSTOMER_PRICE) {
      // case #3-2
      return this.item_name_2;
    } else if (productCase === CASE_SINGLE) {
      // case #1
      return this.item.item_name_2;
    }
    return this.item_name_2;
  }

  get priceIndustry(): number {
    const currentUser: User = store.state.Auth.userLogging;
    if (currentUser.customer.industry_code === "11") {
      return this.item.shop_price;
    }
    return this.item.user_price;
  }

  get getPrice(): number {
    const productCase = this.getCase;
    let price = this.item.user_price;
    if (productCase === CASE_NORMAL) {
      price = this.priceIndustry * this.unit_quantity;
    } else if (productCase === CASE_SINGLE) {
      price = this.priceIndustry;
    } else if (productCase === CASE_SINGLE_CUSTOMER_PRICE) {
      price = this.customer_price.customer_price;
    } else if (productCase === CASE_CUSTOMER_PRICE) {
      price = this.customer_price.customer_price * this.unit_quantity;
    }
    return price;
  }

  get getPriceDisplay(): string {
    return new Intl.NumberFormat().format(this.getPrice);
  }

  get getPriceIncludeTax(): string {
    return new Intl.NumberFormat().format(
      this.getPrice + this.getPrice * (this.getTax / 100)
    );
  }

  get getItemDescription(): string {
    return this.item.description;
  }
  get getDescription(): string {
    return this.carton_description;
  }

  get getItemCode(): string {
    return "NO." + this.item_carton_code;
  }

  get getCategoryName(): string {
    return this.item.item_category.name || "";
  }

  get getImageUrl(): string {
    if (this.item.files && this.item.files[0]) {
      return this.item.files[0].file_path_full;
    }

    return "";
  }

  get getUnitName(): string {
    return this.unit_quantity + this.unit_name;
  }

  get getCase(): string {
    if (this.unit_quantity === 1 && this.customer_price) {
      // case #3-1
      return CASE_SINGLE_CUSTOMER_PRICE;
    } else if (this.unit_quantity > 1 && this.customer_price) {
      // case #3-2
      return CASE_CUSTOMER_PRICE;
    }
    if (this.unit_quantity === 1) {
      // case #1
      return CASE_SINGLE;
    }
    return CASE_NORMAL;
  }

  get getTax(): number {
    const tax: number = store.state.Customer.tax;
    return tax;
  }

  get getDisableDeliveryDay(): string[] {
    if (this.can_deliver_today) {
      return [];
    } else {
      if (this.delivery_day_inquiry_kbn > 1) {
        const currentDay = moment();
        const disableDays = [];
        for (let index = 0; index < this.delivery_day_inquiry_kbn; index++) {
          disableDays.push(currentDay.format(DATE_TIME_FORMAT));
          currentDay.add(1, "day");
        }
        return disableDays;
      }
    }
    return [];
  }
}
